import styled from "styled-components";

/** Blocos de estatísticas (Meta, Bank View, etc.) — mesmo visual em cards escuros */

export const StatsIntro = styled.p`
    margin: 0 0 18px 0;
    padding: 0 4px;
    color: rgba(255, 255, 255, 0.55);
    font-size: 14px;
    line-height: 1.5;

    @media (min-width: 768px) {
        font-size: 15px;
        margin-bottom: 22px;
    }
`;

export const StatStack = styled.div`
    display: flex;
    flex-direction: column;
    gap: 12px;

    @media (min-width: 768px) {
        gap: 14px;
    }
`;

export const StatItem = styled.div`
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 18px;
    border-radius: 14px;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.06) 0%, rgba(255, 255, 255, 0.02) 100%);
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-left: 4px solid ${(p) => p.$accent};
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
    transition: transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease;

    &:hover {
        transform: translateY(-2px);
        box-shadow: 0 12px 32px rgba(0, 0, 0, 0.28);
        border-color: rgba(255, 255, 255, 0.12);
    }

    @media (min-width: 768px) {
        padding: 18px 22px;
        gap: 18px;
    }
`;

export const StatIconWrap = styled.div`
    width: 48px;
    height: 48px;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    font-size: 20px;
    background: ${(p) => p.$bg};
    color: ${(p) => p.$fg};
    box-shadow: 0 4px 14px ${(p) => p.$shadow};

    @media (min-width: 768px) {
        width: 52px;
        height: 52px;
        font-size: 22px;
    }
`;

export const StatText = styled.div`
    flex: 1;
    min-width: 0;
`;

export const StatLabel = styled.div`
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    color: #9aa3c4;
    margin-bottom: 4px;
    line-height: 1.3;

    @media (min-width: 768px) {
        font-size: 12px;
    }
`;

export const StatHint = styled.div`
    font-size: 12px;
    color: rgba(255, 255, 255, 0.45);
    line-height: 1.35;
    display: none;

    @media (min-width: 480px) {
        display: block;
    }
`;

export const StatValue = styled.div`
    font-size: clamp(1.05rem, 3.2vw, 1.35rem);
    font-weight: 800;
    color: ${(p) => p.$c};
    line-height: 1.25;
    text-align: right;
    flex-shrink: 0;
    font-variant-numeric: tabular-nums;
    max-width: 52%;
    word-break: break-word;
`;
